import styled from '@emotion/styled';
import { Radio } from '../atoms/Radio';
import { FormField } from './FormField';

interface RadioGroupProps<T extends string = string> {
  label: string;
  name: string;
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const RadioContainer = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing(2)};
  flex-wrap: wrap;
`;

export const RadioGroup = <T extends string = string>({
  label,
  name,
  options,
  value,
  onChange,
  required = false,
  disabled = false,
  className,
}: RadioGroupProps<T>) => {
  return (
    <FormField label={label} required={required} className={className}>
      <RadioContainer>
        {options.map((option) => (
          <Radio
            key={option.value}
            name={name}
            value={option.value}
            label={option.label}
            checked={value === option.value}
            disabled={disabled}
            onChange={() => onChange(option.value)}
          />
        ))}
      </RadioContainer>
    </FormField>
  );
};
